import type { SylvanusApiTyped } from './types';

import './setup';
import { sylvanusApiRoot } from './root';

export const sylvanus = sylvanusApiRoot as SylvanusApiTyped;
